import { TBusinessType } from '../../../entities/general.entities';
import {
  IMusselSeeding,
  IOysterSeeding,
  ISeaweedSeeding,
  ISeedingResource,
} from '../../../entities/growing.entities';
import MusselSeedViewModal from './MusselSeedViewModal';
import OysterSeedViewModal from './OysterSeedViewModal';
import SeaweedSeedViewModal from './SeaweedSeedViewModal';

interface Props {
  visible: boolean;
  seeding: ISeedingResource;
  onClose: () => void;
}

const SeedViewModal = ({ visible, seeding, onClose }: Props) => (
  <>
    {seeding.line.crop_type === 'MUSSEL' ? (
      <MusselSeedViewModal
        visible={visible}
        seeding={seeding as IMusselSeeding}
        onClose={onClose}
      />
    ) : seeding.line.crop_type === 'OYSTER' ? (
      <OysterSeedViewModal
        visible={visible}
        seeding={seeding as IOysterSeeding}
        onClose={onClose}
      />
    ) : seeding.line.crop_type === 'SEAWEED' ? (
      <SeaweedSeedViewModal
        visible={visible}
        seeding={seeding as ISeaweedSeeding}
        onClose={onClose}
      />
    ) : (
      <></>
    )}
  </>
);

export default SeedViewModal;
